export const AUDITORIA = () => '/auditoria';